import { TranslateService } from '@ngx-translate/core';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { userdata, UserLoginComponent } from '../user-login/user-login.component';
import { MyapiService } from '../../services/myapi.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthUser } from '@src/app/models/user/user';
import { Store } from '@ngrx/store';
import { loadAuthUserFailure, loadAuthUserSuccess } from '@src/app/store/user/user.actions';
import { FacebookLoginProvider, SocialAuthService } from 'angularx-social-login';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { AuthService } from '@src/app/services/user-managment/authentication/authentication.service';
import {OtpService} from '../../services/user-managment/authentication/otp.service'
import {REGISTER_STATUS} from '../../constant/statuses'
import { CountryISO } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-user-signup',
  templateUrl: './user-signup.component.html',
  styleUrls: ['./user-signup.component.scss']
})
export class UserSignupComponent implements OnInit {
  subscription: Subscription = new Subscription();

  userLoader: boolean = false;

    error: boolean = false;
    hidePassword = true; 
    hideConfirmPassword = true;
    CountryISO = CountryISO;



  showPassword = false;
  showConfirmPassword = false;
  signupform: FormGroup;
  public getScreenWidth: any;
  constructor(
    private myapi: MyapiService,
    private _snackBar: MatSnackBar,
    private Router: Router,
    public translate: TranslateService,
    public dialog: MatDialog,
    public authService : AuthService,
    public otpService :OtpService,
    private location: Location,
    private readonly store: Store) { }

  ngOnInit() {
    this.getScreenWidth = window.innerWidth;
    
    this.authService.initRegisterForm();

        this.registerForm.get('userPhoneNumber')?.clearValidators();
        this.registerForm.get('userPhoneNumber')?.updateValueAndValidity();


    this.subscription.add(
      this.authService.notify.subscribe({
        next: (status) => {
          
          if (status === REGISTER_STATUS.success) {
              console.log('REGISTER_STATUS.success reached ✅');

            this.otpService.setOtpStatus(true);
            this.dialog.closeAll()
            this.Router.navigate(['/otp']);
          } else {
            this.error = true;
          }
        }
      })
    );
  }
  registerSubmit() {
    this.error = false;
    console.log(this.registerForm.errors)

    
    if (!this.authService.registerForm.valid) {
      this.error = true;
    } else {
      const phone = this.authService.registerForm.get('userPhoneNumber');
      if(phone && phone.value){
        phone.setValue(phone.value.number)        
      }
      this.authService.regitserSubmit();
    }
  }

  get getFirstNameErrorMessage() {
    return this.authService.getFirstNameErrorMessage;
  }

  get getLastNameErrorMessage() {
    return this.authService.getLastNameErrorMessage;
  }

  get getUserNameErrorMessage() {
    return this.authService.getUserNameErrorMessage;
  }

  get getPhoneErrorMessage() {
    const phoneControl = this.getRegisterFormControl('userPhoneNumber');
    if (phoneControl.hasError('required')) {
      return this.lang === 'en' ? 'Phone number is required.' : 'رقم الهاتف مطلوب.';
    }
    if (phoneControl.hasError('maxlength')) {
      return this.lang === 'en' ? 'Phone number cannot exceed 14 characters.' : 'رقم الهاتف لا يمكن أن يتجاوز 14 حرفًا.';
    }
    return '';
  }

  get getEmailErrorMessage() {
    return this.authService.getEmailErrorMessage;
  }

  get getPasswordErrorMessage() {
    return this.authService.getPasswordErrorMessage;
  }

  getRegisterFormControl(controlName: string) {
    return this.authService.registerForm.controls[controlName];
  }

  get isLoading() {
    return this.authService.isLoading;
  }


  get registerForm() {
    return this.authService.registerForm;
  }

  get lang() {
    return this.translate.currentLang === 'en' ? 'en' : 'ar';
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }




  openSnackBar(message: string, action: string, Staus: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      panelClass: [Staus]
    });
  }
  toHomepage() {
    this.Router.navigate(['/']);
  }

  toLogin() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(UserLoginComponent,{ panelClass: 'custom-dialog-container'});
  }

  closeDialog() {
    this.dialog.closeAll()
  }
  close(){
    
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // submitFbLogin(){
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  // }
  
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
  }
}
